module.exports = __webpack_public_path__ + "bd8bf68c61da741c97081ec568366f80.svg";